export const isInnValid = (inn: string): boolean => {
  // Проверяем, что все символы являются цифрами
  const isNumeric: boolean = /^\d+$/.test(inn);
  const isValidLength: boolean = inn.length === 10 || inn.length === 12;

  return isNumeric && isValidLength;
};